import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query searchLocationGroups($where: LocationGroupWhereInput, $limit: Int, $offset: Int) {\n    locationsGroups(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query searchLocationGroups($where: LocationGroupWhereInput, $limit: Int, $offset: Int) {\n    locationsGroups(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"])));
var FcLocationGroupsInputComponent = /** @class */ (function () {
    function FcLocationGroupsInputComponent(fuseTranslationLoaderService, apollo) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.apollo = apollo;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcLocationGroupsInputComponent.prototype.search = function (searchTerm, limit, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_QUERY,
                        variables: {
                            where: {
                                name_contains: searchTerm,
                                archived: false
                            },
                            limit: limit,
                            offset: offset
                        },
                    })
                        .toPromise()
                        .then(function (result) { return result.data['locationsGroups']['items']; })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcLocationGroupsInputComponent.prototype.displayWith = function (value) {
        return value && value.name;
    };
    return FcLocationGroupsInputComponent;
}());
export { FcLocationGroupsInputComponent };
var templateObject_1;
